window.addEventListener('pageshow', function(event) {
  if (event.persisted) {
    window.location.reload();
  }
});

document.addEventListener('DOMContentLoaded', function () {
  const updateHeaderMargin = () => {
    const header = document.querySelector('.p-header');
    const mainContent = document.getElementById('main-content');
    if (header && mainContent) {
      mainContent.style.marginTop = header.offsetHeight + 'px';
    }
  };
  updateHeaderMargin();
  window.addEventListener('resize', updateHeaderMargin);

  const searchBar = document.getElementById('search-bar');
  const menuBar = document.getElementById('menu-bar');
  const openBtn = document.getElementById('header_menu_open');
  const closeBtn = document.querySelector('.p-menu__icon');

  const openSearch = () => {
    if (searchBar) searchBar.style.left = '0';
  };
  const closeSearch = () => {
    if (searchBar) searchBar.style.left = '-100%';
  };

  document.querySelectorAll('#sp-search, #header_search').forEach(el => {
    el?.addEventListener('click', openSearch);
  });

  document.getElementById('close-search')?.addEventListener('click', closeSearch);

  let overlay = document.querySelector('.menu-overlay');
  if (!overlay) {
    overlay = document.createElement('div');
    overlay.classList.add('menu-overlay');
    document.body.appendChild(overlay);
  }

  const openMenu = () => {
    if (!menuBar) return;
    menuBar.style.display = 'block';
    requestAnimationFrame(() => {
      menuBar.classList.add('is-open');
      overlay.classList.add('is-visible');
      document.body.classList.add('is-locked');
    });
  };

  const closeMenu = () => {
    if (!menuBar) return;
    menuBar.classList.remove('is-open');
    overlay.classList.remove('is-visible');
    document.body.classList.remove('is-locked');
    setTimeout(() => { menuBar.style.display = 'none'; }, 300);
  };

  openBtn?.addEventListener('click', openMenu);
  closeBtn?.addEventListener('click', closeMenu);
  overlay.addEventListener('click', closeMenu);

  const setupSwipeClose = (element, onClose, threshold = 50) => {
    if (!element) return;

    let startX = 0;
    let startY = 0;
    let tracking = false;

    element.addEventListener('touchstart', (e) => {
      if (!e.touches || !e.touches[0]) return;
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      tracking = true;
    }, { passive: true });

    element.addEventListener('touchmove', (e) => {
      if (!tracking || !e.touches || !e.touches[0]) return;

      const dx = e.touches[0].clientX - startX;
      const dy = e.touches[0].clientY - startY;

      if (Math.abs(dy) > Math.abs(dx)) return;

      if (dx < -threshold) {
        tracking = false;
        onClose();
      }
    }, { passive: true });

    element.addEventListener('touchend', () => {
      tracking = false;
    }, { passive: true });

    element.addEventListener('touchcancel', () => {
      tracking = false;
    }, { passive: true });
  };

  setupSwipeClose(searchBar, closeSearch);
  setupSwipeClose(menuBar, closeMenu);
  setupSwipeClose(overlay, closeMenu);

  const productCarouselEl = document.querySelector('#product-carousel');
  const thumbCarouselEl = document.querySelector('#thumbnails-carousel');

  if (productCarouselEl && thumbCarouselEl) {
    if (!productCarouselEl.classList.contains('is-mounted')) {
    }
  }
});

